import { shadows, borderRadius, typography, spacing, transitions, zIndex, colors } from './tokens';
export const lightTheme = {
    mode: 'light',
    colors: {
        bg: {
            primary: '#f5f3ff',
            secondary: '#ede9fe',
            tertiary: '#ddd6fe',
            inverse: colors.neutral[900],
        },
        text: {
            primary: '#1e0a4c',
            secondary: colors.primary[900],
            tertiary: colors.primary[700],
            inverse: colors.neutral[0],
            link: colors.primary[600],
        },
        border: {
            subtle: 'rgba(109,40,217,0.10)',
            default: 'rgba(109,40,217,0.18)',
            strong: 'rgba(109,40,217,0.30)',
        },
        brand: {
            primary: colors.primary[600],
            primaryHover: colors.primary[500],
            primaryActive: colors.primary[700],
            primaryText: colors.neutral[0],
            accent: colors.accent[600],
            accentHover: colors.accent[500],
        },
        success: colors.success.dark,
        warning: colors.warning.dark,
        error: colors.error.dark,
        info: colors.info.dark,
    },
    shadows,
    borderRadius,
    typography,
    spacing,
    transitions,
    zIndex,
};
//# sourceMappingURL=lightTheme.js.map